
import store from '@/store';
import router from '@/router'
import { Options, Vue } from 'vue-class-component';
import StartRating from '../common/StarRating.vue'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
Vue.registerHooks([
    'beforeRouteEnter',
    'beforeRouteLeave',
    'beforeRouteUpdate'
])
@Options({

    components: {
        StartRating,
        FontAwesomeIcon
    },
    props: {
        restorantId: {
            type: String,
            required: true
        }
    }
})
export default class RestorantDetails extends Vue {
    restorantId!: string
    faPlus = faPlus;
    get restorant() {
        return store.getters.availableRestorants.find((z: { id: string; }) => z.id == this.restorantId);
    }
    get topProducts() {
        return this.restorant.products.slice(0, 4);
    }
    addToCart(productId: string) {
        store.dispatch('addToCart', this.restorant.products.find((z: any) => z.id == productId));
    }
    goBack() {
        if(history.state.back){
            router.back();
        }
        else{
            router.push({name:'restorants'})
        }
    }
    beforeRouteEnter(to: any, from: any) {
        // called before the route that renders this component is confirmed.
        // does NOT have access to `this` component instance,
        // because it has not been created yet when this guard is called!
        console.log('beforeRouteEnter', to, from)
    }
    beforeRouteUpdate(to: any, from: any) {
        // called when the route that renders this component has changed, but this component is reused in the new route.
        // For example, given a route with params `/users/:id`, when we navigate between `/users/1` and `/users/2`,
        // the same `UserDetails` component instance will be reused, and this hook will be called when that happens.
        // Because the component is mounted while this happens, the navigation guard has access to `this` component instance.
        console.log('beforeRouteUpdate', to, from)
    }
    beforeRouteLeave(to: any, from: any) {
        // called when the route that renders this component is about to be navigated away from.
        // As with `beforeRouteUpdate`, it has access to `this` component instance.
        if (store.state.cart.items.length > 0) {
            const answer = window.confirm('Do you really want to leave? You have not completed your order!')
            if (!answer) return false
        }

    }
}
